import { i18n } from '@/i18n';

/**
 * 把当前 locale 作为 lang 参数拼到 URL 上。easy-mail iframe 和 martech 主站跨 origin，
 * 不能共享 localStorage，必须通过 URL 显式传递 lang，初始渲染才能拿到正确语言。
 * 与 cartsee-front 的 src/utils/easyMailOrigin.ts 对称（spec §2.2.3）。
 */
export function appendLangParam(url: string): string {
  const lang = (i18n.locale as string) || 'zh-CN';
  const sep = url.includes('?') ? '&' : '?';
  return `${url}${sep}lang=${encodeURIComponent(lang)}`;
}

/**
 * ready handshake（spec §2.2.6）：easy-mail iframe 挂好 postMessageBridge 后向父窗口发
 * `{event:'easy-mail:ready', source:'easy-mail'}`。当前业务用 iframe.onload 做首次消息发送，
 * 等价于首次 ready；本工具为未来 iframe 生命周期中的二次通信（如 setLocale reload 后重发
 * initialEmailData）提供可靠等待点。
 *
 * @param timeoutMs 超时毫秒；超时后仍 resolve（降级）
 */
export function onEasyMailReady(timeoutMs = 5000): Promise<void> {
  return new Promise((resolve) => {
    let settled = false;
    const finish = () => {
      if (settled) return;
      settled = true;
      window.removeEventListener('message', handler);
      resolve();
    };
    const handler = (event: MessageEvent) => {
      const d = event.data;
      if (d && typeof d === 'object' && d.event === 'easy-mail:ready' && d.source === 'easy-mail') {
        finish();
      }
    };
    window.addEventListener('message', handler);
    setTimeout(finish, timeoutMs);
  });
}
